import React from 'react';

/**
 * CP-6445: the 1-panel chat view hides panels with `display: none` instead of
 * unmounting them, and `selectedScreen` can change from a route event with no click
 * anywhere in the page (browser Back/Forward, a push-notification click, or a Twilio
 * `updated` event calling history.replace). An open Menu/Popover therefore survives the
 * switch, leaving an invisible full-viewport backdrop that swallows wheel and click
 * events until the user happens to click.
 *
 * `selectedScreen` may be undefined where a menu is rendered outside the 1-panel
 * layout; the effect then never fires.
 */
export default function useCloseOnPanelChange(selectedScreen, close) {
    const closeRef = React.useRef(close);
    closeRef.current = close;
    const previousScreen = React.useRef(selectedScreen);

    React.useEffect(() => {
        if (previousScreen.current === selectedScreen) { return; }
        previousScreen.current = selectedScreen;
        closeRef.current?.();
    }, [selectedScreen]);
}
